// extracted by mini-css-extract-plugin
module.exports = {"buttonRoot":"SizeGuide_buttonRoot__zZElF","sizeLabel":"SizeGuide_sizeLabel__fcwBv"};